import { render, staticRenderFns } from "./warningFlag.vue?vue&type=template&id=07933cb5&scoped=true"
import script from "./warningFlag.vue?vue&type=script&lang=js"
export * from "./warningFlag.vue?vue&type=script&lang=js"
import style0 from "./warningFlag.vue?vue&type=style&index=0&id=07933cb5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07933cb5",
  null
  
)

export default component.exports